import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import {
  useSlotGroup,
  EditableSlotGroup,
  RichTextContent,
} from '@vibesites/runtime/react';
import { requestOpenApplyModal } from '../utils/applyModal';
import { btnOnDark } from '../utils/buttonStyles';

const ctaLinkDef: SlotGroupDefinition = {
  label: 'Start Application CTA',
  fields: {
    url: {
      label: 'URL',
      type: 'url',
      defaultField: 'property_apply_now_url',
      suggestedFields: ['property_apply_now_url', 'property_website_url'],
    },
    label: { label: 'Label', type: 'text', defaultValue: 'START APPLICATION' },
    _target: { label: 'Link Target', type: 'text', defaultValue: '_self' },
  },
};

export function ApplyCtaBanner() {
  const ctaLink = useSlotGroup('applyctabanner.cta_link', ctaLinkDef);

  return (
    <section className="bg-primary py-16 md:py-20 px-4 sm:px-6 text-center">
      <div className="mx-auto flex max-w-5xl flex-col items-center">
        <RichTextContent
          path="applyctabanner.headline"
          as="h2"
          className="font-body text-balance text-[clamp(0.875rem,2.5vw,1.875rem)] font-medium tracking-[0.2em] uppercase text-primary-foreground leading-snug lg:whitespace-nowrap lg:leading-none"
        />

        <EditableSlotGroup groupPath="applyctabanner.cta_link" definition={ctaLinkDef}>
          <button
            type="button"
            onClick={requestOpenApplyModal}
            className={`mt-6 md:mt-8 inline-flex items-center justify-center px-10 py-4 font-body text-sm font-medium tracking-[0.2em] uppercase cursor-pointer ${btnOnDark}`}
          >
            {ctaLink.label || 'START APPLICATION'}
          </button>
        </EditableSlotGroup>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'ApplyCtaBanner',
  displayName: 'Apply CTA Banner',
  tokens: {
    'applyctabanner.headline': {
      label: 'Headline',
      type: 'richtext',
      defaultValue: '<p>BRAND NEW APARTMENT HOMES - AVAILABLE NOW</p>',
    },
  },
  slotGroups: {
    'applyctabanner.cta_link': ctaLinkDef,
  },
};

(ApplyCtaBanner as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default ApplyCtaBanner;
